import { render } from "./Settings.vue?vue&type=template&id=7502993f&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=7502993f&scoped=true&lang=css"
import "./Settings.vue?vue&type=style&index=1&id=7502993f&lang=scss"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7502993f"]])

export default __exports__